import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { dataService } from '../../../Services/data.service';
import { makeStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { NavLink } from 'react-router-dom';
import BackForwardButton from '../../Shared/BackForwardButton';
import RecyclingHistoryOverviewTable from './RecyclingHistoryOverviewTable';
import { Button } from '@mui/material';
// Icons
import { ListFilter, X } from 'lucide-react';

export const RecyclePage = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [showFilters, setShowFilters] = useState(false);
    const [loading, setLoading] = useState(true);

    const [recyclingHistory, setRecyclingHistory] = useState([]);

    useEffect(() => {
        dataService.getRecyclingHistory().then((response) => {
            setRecyclingHistory(response);
            setLoading(false);
        }).catch((error) => {
            console.log(error);
        });
    }, []);

    const handleFilter = () => {
        setShowFilters(!showFilters);
    }

    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <div className={classes.header__titleContainer}>
                    <NavLink className={classes.navButton} to={`/recycle`}>
                        <BackForwardButton direction={'Back'} textOverride={t("Back to recycle page")}></BackForwardButton>
                    </NavLink>
                    <h1 className={classes.header__title}>
                        {t("Recycling History")}
                    </h1>
                </div>

                <Button className={classes.header__button} onClick={() => handleFilter()}>
                    {showFilters ?
                        <X size={24} />
                        :
                        <ListFilter size={24} />
                    }
                    {t("Filter")}
                </Button>
            </div>
            <div className={classes.tableContainer}>
                <RecyclingHistoryOverviewTable loading={loading} recyclingHistory={recyclingHistory} showFilters={showFilters} />
            </div>
        </div>
    );
}

const useStyles = makeStyles({
    container: {
        width: '100%',
        position: "relative",
        top: "20px",
    },

    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        position: "relative",

        padding: "0px 24px",
    },

    header__titleContainer: {
        display: "flex",
        flexDirection: "column",
    },

    header__title: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',

        color: "#0C0E29",

        margin: "0px",
    },

    header__button: {
        color: FlagstoneTheme.palette.primary.main + " !important",
        fontSize: "16px !important",
        fontWeight: "bold !important",
        fontFamily: "Lato, sans-serif !important",
        backgroundColor: "transparent !important",
        border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        minWidth: "fit-content !important",
        height: '40px !important',
        padding: '0px 20px !important',
        paddingLeft: '8px !important',
        textTransform: 'capitalize !important',

        display: 'flex !important',
        justifyContent: 'center !important',
        alignItems: 'center !important',
        gap: '8px !important',

        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
            color: "white !important",
            border: "1px solid " + FlagstoneTheme.palette.primary.main + " !important",
        },
        '&:disabled': {
            backgroundColor: "lightgrey !important",
            color: "white !important",
            border: "1px solid darkgrey !important",
            cursor: "not-allowed !important"
        },
    },

    tableContainer: {
        marginTop: "24px",
        padding: "0px 24px",
    },
});

function mapStateToProps(state) {
    return {
        workstation: state.workstation
    }
}

export default connect(mapStateToProps)(RecyclePage);